import { ScrollView, YStack } from 'tamagui';

import {
    BodyLargeEmphasized,
    BodyLargeRegular,
    BodyMediumEmphasized,
    BodyMediumRegular,
    BodySmallEmphasized,
    BodySmallRegular,
    FootnoteEmphasized,
    FootnoteRegular,
    H1Emphasized,
    H1Regular,
    H2Emphasized,
    H2Regular,
    H3Emphasized,
    H3Regular,
    H5Emphasized,
    H5Regular,
    H6Emphasized,
    H6Regular,
    HeroEmphasized,
    HeroRegular,
    LabelEmphasized,
    LabelRegular,
    MonoBodyLargeEmphasized,
    MonoBodyLargeRegular,
    MonoBodyMediumEmphasized,
    MonoBodyMediumRegular,
    MonoBodySmallEmphasized,
    MonoBodySmallRegular,
    MonoFootnoteEmphasized,
    MonoFootnoteRegular,
    MonoLabelEmphasized,
    MonoLabelRegular,
} from '../../components/text/Typography';
import { tokens } from '../../tamagui.config';

export const Typography = () => {
    return (
        <ScrollView horizontal>
            <YStack gap={48}>
                <Heros />
                <Headings />
                <Text />
                <ItalicText />
                <MonoText />
            </YStack>
        </ScrollView>
    );
};

const Heros = () => {
    const size = tokens.font.heading.size;

    return (
        <YStack gap={8}>
            <HeroEmphasized>HeroEmphasized ({size[5]})</HeroEmphasized>
            <HeroRegular>HeroRegular ({size[5]})</HeroRegular>
        </YStack>
    );
};

const Headings = () => {
    const size = tokens.font.heading.size;

    return (
        <YStack marginBottom={8} gap={16}>
            <YStack gap={8}>
                <H1Emphasized>H1Emphasized ({size[4]})</H1Emphasized>
                <H2Emphasized>H2Emphasized ({size[3]})</H2Emphasized>
                <H3Emphasized>H3Emphasized (28)</H3Emphasized>
                <H5Emphasized>H5Emphasized ({size[2]})</H5Emphasized>
                <H6Emphasized>H6Emphasized ({size[1]})</H6Emphasized>
            </YStack>
            <YStack gap={8}>
                <H1Regular>H1Regular ({size[4]})</H1Regular>
                <H2Regular>H2Regular ({size[3]})</H2Regular>
                <H3Regular>H3Regular (28)</H3Regular>
                <H5Regular>H5Regular ({size[2]})</H5Regular>
                <H6Regular>H6Regular ({size[1]})</H6Regular>
            </YStack>
        </YStack>
    );
};

const Text = () => {
    const size = tokens.font.body.size;

    return (
        <YStack marginBottom={8} gap={16}>
            <YStack gap={8}>
                <BodyLargeEmphasized>
                    BodyLargeEmphasized ({size[5]})
                </BodyLargeEmphasized>
                <BodyMediumEmphasized>
                    BodyMediumEmphasized ({size[4]})
                </BodyMediumEmphasized>
                <BodySmallEmphasized>
                    BodySmallEmphasized ({size[3]})
                </BodySmallEmphasized>
                <FootnoteEmphasized>
                    FootnoteEmphasized ({size[2]})
                </FootnoteEmphasized>
                <LabelEmphasized>LabelEmphasized ({size[1]})</LabelEmphasized>
            </YStack>
            <YStack gap={8}>
                <BodyLargeRegular>
                    BodyLargeRegular ({size[5]})
                </BodyLargeRegular>
                <BodyMediumRegular>
                    BodyMediumRegular ({size[4]})
                </BodyMediumRegular>
                <BodySmallRegular>
                    BodySmallRegular ({size[3]})
                </BodySmallRegular>
                <FootnoteRegular>FootnoteRegular ({size[2]})</FootnoteRegular>
                <LabelRegular>LabelRegular ({size[1]})</LabelRegular>
            </YStack>
        </YStack>
    );
};

const ItalicText = () => {
    const bodySize = tokens.font.body.size;
    const headingSize = tokens.font.heading.size;

    return (
        <YStack marginBottom={8} gap={16}>
            <YStack gap={8}>
                <HeroEmphasized fontStyle="italic">
                    HeroEmphasized italic ({headingSize[5]})
                </HeroEmphasized>
                <HeroRegular fontStyle="italic">
                    HeroRegular italic ({headingSize[5]})
                </HeroRegular>
            </YStack>
            <YStack gap={8}>
                <H1Emphasized fontStyle="italic">
                    H1Emphasized italic ({headingSize[4]})
                </H1Emphasized>
                <H2Emphasized fontStyle="italic">
                    H2Emphasized italic ({headingSize[3]})
                </H2Emphasized>
                <H3Emphasized fontStyle="italic">
                    H3Emphasized italic (28)
                </H3Emphasized>
                <H5Emphasized fontStyle="italic">
                    H5Emphasized italic ({headingSize[2]})
                </H5Emphasized>
                <H6Emphasized fontStyle="italic">
                    H6Emphasized italic ({headingSize[1]})
                </H6Emphasized>
            </YStack>
            <YStack gap={8}>
                <H1Regular fontStyle="italic">
                    H1Regular italic ({headingSize[4]})
                </H1Regular>
                <H2Regular fontStyle="italic">
                    H2Regular italic ({headingSize[3]})
                </H2Regular>
                <H3Regular fontStyle="italic">H3Regular italic (28)</H3Regular>
                <H5Regular fontStyle="italic">
                    H5Regular italic ({headingSize[2]})
                </H5Regular>
                <H6Regular fontStyle="italic">
                    H6Regular italic ({headingSize[1]})
                </H6Regular>
            </YStack>
            <YStack gap={8}>
                <BodyLargeEmphasized fontStyle="italic">
                    BodyLargeEmphasized italic ({bodySize[5]})
                </BodyLargeEmphasized>
                <BodyMediumEmphasized fontStyle="italic">
                    BodyMediumEmphasized italic ({bodySize[4]})
                </BodyMediumEmphasized>
                <BodySmallEmphasized fontStyle="italic">
                    BodySmallEmphasized italic ({bodySize[3]})
                </BodySmallEmphasized>
                <FootnoteEmphasized fontStyle="italic">
                    FootnoteEmphasized italic ({bodySize[2]})
                </FootnoteEmphasized>
                <LabelEmphasized fontStyle="italic">
                    LabelEmphasized italic ({bodySize[1]})
                </LabelEmphasized>
            </YStack>
            <YStack gap={8}>
                <BodyLargeRegular fontStyle="italic">
                    BodyLargeRegular italic ({bodySize[5]})
                </BodyLargeRegular>
                <BodyMediumRegular fontStyle="italic">
                    BodyMediumRegular italic ({bodySize[4]})
                </BodyMediumRegular>
                <BodySmallRegular fontStyle="italic">
                    BodySmallRegular italic ({bodySize[3]})
                </BodySmallRegular>
                <FootnoteRegular fontStyle="italic">
                    FootnoteRegular italic ({bodySize[2]})
                </FootnoteRegular>
                <LabelRegular fontStyle="italic">
                    LabelRegular italic ({bodySize[1]})
                </LabelRegular>
            </YStack>
        </YStack>
    );
};

const MonoText = () => {
    const size = tokens.font.body.size;

    return (
        <YStack marginBottom={8} gap={16}>
            <YStack gap={8}>
                <MonoBodyLargeEmphasized>
                    MonoBodyLargeEmphasized ({size[5]})
                </MonoBodyLargeEmphasized>
                <MonoBodyMediumEmphasized>
                    MonoBodyMediumEmphasized ({size[4]})
                </MonoBodyMediumEmphasized>
                <MonoBodySmallEmphasized>
                    MonoBodySmallEmphasized ({size[3]})
                </MonoBodySmallEmphasized>
                <MonoFootnoteEmphasized>
                    MonoFootnoteEmphasized ({size[2]})
                </MonoFootnoteEmphasized>
                <MonoLabelEmphasized>
                    MonoLabelEmphasized ({size[1]})
                </MonoLabelEmphasized>
            </YStack>
            <YStack gap={8}>
                <MonoBodyLargeRegular>
                    MonoBodyLargeRegular ({size[5]})
                </MonoBodyLargeRegular>
                <MonoBodyMediumRegular>
                    MonoBodyMediumRegular ({size[3]})
                </MonoBodyMediumRegular>
                <MonoBodySmallRegular>
                    MonoBodySmallRegular ({size[3]})
                </MonoBodySmallRegular>
                <MonoFootnoteRegular>
                    MonoFootnoteRegular ({size[2]})
                </MonoFootnoteRegular>
                <MonoLabelRegular>
                    MonoLabelRegular ({size[1]})
                </MonoLabelRegular>
            </YStack>
        </YStack>
    );
};
